const testimonialCards = [
  {
    name: "Ed Arriola, Let’s Go Tours",
    description:
      "It’s a real relief for me, because I don’t have a marketing division. So I’m more than willing to work with Video Husky who: 1. Can save me a lot of money, and 2. Can turn my vision on paper into something extremely nice.",
    imgName: "",
  },
  {
    name: "Brady Winder, Carrot.com",
    description:
      "It’s a real relief for me, because I don’t have a marketing division. So I’m more than willing to work with Video Husky who: 1. Can save me a lot of money, and 2. Can turn my vision on paper into something extremely nice.",
    imgName: "",
  },
  {
    name: "Hector Patrick, Digital Marketing Gorilla",
    description:
      "It’s a real relief for me, because I don’t have a marketing division. So I’m more than willing to work with Video Husky who: 1. Can save me a lot of money, and 2. Can turn my vision on paper into something extremely nice.",
    imgName: "",
  },
  {
    name: "Ed Arriola, Let’s Go Tours",
    description:
      "It’s a real relief for me, because I don’t have a marketing division. So I’m more than willing to work with Video Husky who: 1. Can save me a lot of money, and 2. Can turn my vision on paper into something extremely nice.",
    imgName: "",
  },
  {
    name: "Ed Arriola, Let’s Go Tours",
    description:
      "It’s a real relief for me, because I don’t have a marketing division. So I’m more than willing to work with Video Husky who: 1. Can save me a lot of money, and 2. Can turn my vision on paper into something extremely nice.",
    imgName: "",
  },
  {
    name: "Ed Arriola, Let’s Go Tours",
    description:
      "It’s a real relief for me, because I don’t have a marketing division. So I’m more than willing to work with Video Husky who: 1. Can save me a lot of money, and 2. Can turn my vision on paper into something extremely nice.",
    imgName: "",
  },
  {
    name: "Ed Arriola, Let’s Go Tours",
    description:
      "It’s a real relief for me, because I don’t have a marketing division. So I’m more than willing to work with Video Husky who: 1. Can save me a lot of money, and 2. Can turn my vision on paper into something extremely nice.",
    imgName: "",
  },
  {
    name: "Ed Arriola, Let’s Go Tours",
    description:
      "It’s a real relief for me, because I don’t have a marketing division. So I’m more than willing to work with Video Husky who: 1. Can save me a lot of money, and 2. Can turn my vision on paper into something extremely nice.",
    imgName: "",
  },
  {
    name: "Ed Arriola, Let’s Go Tours",
    description:
      "It’s a real relief for me, because I don’t have a marketing division. So I’m more than willing to work with Video Husky who: 1. Can save me a lot of money, and 2. Can turn my vision on paper into something extremely nice.",
    imgName: "",
  },
  {
    name: "Ed Arriola, Let’s Go Tours",
    description:
      "It’s a real relief for me, because I don’t have a marketing division. So I’m more than willing to work with Video Husky who: 1. Can save me a lot of money, and 2. Can turn my vision on paper into something extremely nice.",
    imgName: "",
  },
  {
    name: "Ed Arriola, Let’s Go Tours",
    description:
      "It’s a real relief for me, because I don’t have a marketing division. So I’m more than willing to work with Video Husky who: 1. Can save me a lot of money, and 2. Can turn my vision on paper into something extremely nice.",
    imgName: "",
  },
  {
    name: "Ed Arriola, Let’s Go Tours",
    description:
      "It’s a real relief for me, because I don’t have a marketing division. So I’m more than willing to work with Video Husky who: 1. Can save me a lot of money, and 2. Can turn my vision on paper into something extremely nice.",
    imgName: "",
  },
  {
    name: "Ed Arriola, Let’s Go Tours",
    description:
      "It’s a real relief for me, because I don’t have a marketing division. So I’m more than willing to work with Video Husky who: 1. Can save me a lot of money, and 2. Can turn my vision on paper into something extremely nice.",
    imgName: "",
  },
  {
    name: "Ed Arriola, Let’s Go Tours",
    description:
      "It’s a real relief for me, because I don’t have a marketing division. So I’m more than willing to work with Video Husky who: 1. Can save me a lot of money, and 2. Can turn my vision on paper into something extremely nice.",
    imgName: "",
  },
  {
    name: "Ed Arriola, Let’s Go Tours",
    description:
      "It’s a real relief for me, because I don’t have a marketing division. So I’m more than willing to work with Video Husky who: 1. Can save me a lot of money, and 2. Can turn my vision on paper into something extremely nice.",
    imgName: "",
  },
  {
    name: "Ed Arriola, Let’s Go Tours",
    description:
      "It’s a real relief for me, because I don’t have a marketing division. So I’m more than willing to work with Video Husky who: 1. Can save me a lot of money, and 2. Can turn my vision on paper into something extremely nice.",
    imgName: "",
  },
  {
    name: "Ed Arriola, Let’s Go Tours",
    description:
      "It’s a real relief for me, because I don’t have a marketing division. So I’m more than willing to work with Video Husky who: 1. Can save me a lot of money, and 2. Can turn my vision on paper into something extremely nice.",
    imgName: "",
  },
  {
    name: "Ed Arriola, Let’s Go Tours",
    description:
      "It’s a real relief for me, because I don’t have a marketing division. So I’m more than willing to work with Video Husky who: 1. Can save me a lot of money, and 2. Can turn my vision on paper into something extremely nice.",
    imgName: "",
  },
  {
    name: "Ed Arriola, Let’s Go Tours",
    description:
      "It’s a real relief for me, because I don’t have a marketing division. So I’m more than willing to work with Video Husky who: 1. Can save me a lot of money, and 2. Can turn my vision on paper into something extremely nice.",
    imgName: "",
  },
  {
    name: "Ed Arriola, Let’s Go Tours",
    description:
      "It’s a real relief for me, because I don’t have a marketing division. So I’m more than willing to work with Video Husky who: 1. Can save me a lot of money, and 2. Can turn my vision on paper into something extremely nice.",
    imgName: "",
  },
  {
    name: "Ed Arriola, Let’s Go Tours",
    description:
      "It’s a real relief for me, because I don’t have a marketing division. So I’m more than willing to work with Video Husky who: 1. Can save me a lot of money, and 2. Can turn my vision on paper into something extremely nice.",
    imgName: "",
  },
  {
    name: "Ed Arriola, Let’s Go Tours",
    description:
      "It’s a real relief for me, because I don’t have a marketing division. So I’m more than willing to work with Video Husky who: 1. Can save me a lot of money, and 2. Can turn my vision on paper into something extremely nice.",
    imgName: "",
  },
  {
    name: "Ed Arriola, Let’s Go Tours",
    description:
      "It’s a real relief for me, because I don’t have a marketing division. So I’m more than willing to work with Video Husky who: 1. Can save me a lot of money, and 2. Can turn my vision on paper into something extremely nice.",
    imgName: "",
  },
];

export default testimonialCards;
